import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import FirebaseApp, { Collections } from 'src/config/firebase.config';
import { loadZohoForm } from 'src/components/zoho/zohoForm'
const _ = require('lodash');

const EditLeadDetails = (props) => {
  const { formId } = useParams();
  // const { state } = useLocation();
  const [form, setForm] = useState({});
  const FirebaseDB = FirebaseApp.firestore();
  const url = 'https://forms.zohopublic.in/vickyagravat/form/SoftwareEvaluation/formperma/MgmBr4_nF6qCMLyL8myOUVRO79hjPJccV-UiiuAA6H0?zf_rszfm=1'
  const uid = '5qWXH8k124XWX2qBrLrvSq0FZe43'
  console.log(formId);

  const fetchForm = () => {
    FirebaseDB
      .collection(Collections.ZohoForms)
      .doc(formId)
      .get()
      .then((snapshot) => {
        if (snapshot.exists) {
          const data = snapshot.data()
          if (data.createdAt) {
            delete data.createdAt
          }
          if (data.updatedAt) {
            delete data.updatedAt
          }
          setForm({ formId: formId, ...data })
        } else {
          setForm({ formId: formId})
        }
      })
      .catch((e) => console.log(e))
  };

  useEffect(() => {
    fetchForm();
  }, []);

  useEffect(() => {
    if (!_.isEmpty(form)) {
      console.log("lead", form)
      loadZohoForm(url, uid, form)
    }
  }, [form])

  return (
    <div id="zoho-form"></div>
  );
};

export default EditLeadDetails;
